import {Endpoint} from '@eryxcoop/appyx-comm';
import DateAdapter from '../../../adapters/DateAdapter';

export default class CreateAllowanceEndpoint extends Endpoint {
    adaptValues(payload) {
        const dateAdapter = new DateAdapter();
        return {
            concept_name: payload.conceptName,
            valid_from: dateAdapter.adapt(payload.validFrom),
            valid_to: dateAdapter.adapt(payload.validTo),
            beneficiary_kind: payload.beneficiaryKind,
            customer_business_name: payload.customerBusinessName,
            resolution_kind: payload.resolutionKind,
            article_code: payload.articleCode,
            percentage: payload.percentage,
            subject_kind: payload.subjectKind,
            franchise_brand_name: payload.franchiseBrandName,
        };
    }
}
